import React, { HTMLInputTypeAttribute } from 'react';
import InputMask from 'react-input-mask';
import { LabelV2 } from '../../atoms/v2/label/label-v2.atom';
import { InputV2 } from '../../atoms/v2/input/input-v2.atom';
import { InputContainer } from '../../atoms/v2/input-container/input-container.atom';

type Props = {
  label: string;
  placeholder: string;
  type?: HTMLInputTypeAttribute;
  value: any;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  mask?: string;
  maskChar?: string | null;
  maxLength?: number;
  suppressAnalytics?: boolean;
  color?: string;
};

export const InputField: React.FC<Props> = ({
  label,
  placeholder,
  type = 'text',
  value,
  onChange,
  id,
  mask,
  maskChar = null,
  maxLength,
  suppressAnalytics = false,
  color,
}) => {
  const analyticsProps = suppressAnalytics ? { 'data-hj-suppress': true } : {};

  return (
    <InputContainer>
      <LabelV2 htmlFor={id}>{label}</LabelV2>

      {mask ? (
        <InputMask
          mask={mask}
          maskChar={maskChar}
          value={value}
          onChange={onChange}
        >
          {(inputProps: any) => (
            <InputV2
              {...inputProps}
              {...analyticsProps}
              id={id}
              color={color}
              type={type}
              placeholder={placeholder}
              maxLength={maxLength}
            />
          )}
        </InputMask>
      ) : (
        <InputV2
          {...analyticsProps}
          id={id}
          color={color}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          maxLength={maxLength}
        />
      )}
    </InputContainer>
  );
};
